import timeParse from 'date-fns/parse'
import differenceInCalendarDays from 'date-fns/difference_in_calendar_days'

const checkDataError = ({ data, today }) => {
  const [lastDayItem] = data.slice(-1)
  const lastDayObject = timeParse(lastDayItem.reportDate)
  const todayObject = timeParse(today)
  const difference = differenceInCalendarDays(lastDayObject, todayObject)
  return difference >= 1
}

export default checkDataError
